// src/features/dashboard/context.js
import React from "react";

const KEY = "dashboard.periodoId";

export function getStoredPeriodoId() {
  return localStorage.getItem(KEY) || "";
}

export function setStoredPeriodoId(periodoId) {
  if (!periodoId) localStorage.removeItem(KEY);
  else localStorage.setItem(KEY, periodoId);
}

export function useDashboardPeriodo() {
  const [periodoId, setPeriodoId] = React.useState(getStoredPeriodoId);

  const setAndStore = React.useCallback((id) => {
    setPeriodoId(id);
    setStoredPeriodoId(id);
  }, []);

  return { periodoId, setPeriodoId: setAndStore };
}
